import { useEffect, useState } from "react";
import { ChevronDown, Copy, RotateCw } from "lucide-react";
import { toast } from "sonner";
import { api, BACKEND_URL, formatApiError } from "@/lib/api";
import { copyText } from "@/components/PdPill";

export const ForwarderLink = ({ title = "Phone forwarder link (backup)" }) => {
  const [open, setOpen] = useState(false);
  const [path, setPath] = useState("");
  useEffect(() => {
    if (open && !path) api.get("/sms/webhook").then(({ data }) => setPath(data.path)).catch((e) => toast.error(formatApiError(e)));
  }, [open, path]);
  const url = path ? `${BACKEND_URL}${path}` : "";
  const regen = async () => {
    if (!window.confirm("Naya link banana hai? Purana link band ho jayega, forwarder app me naya link daalna padega.")) return;
    const { data } = await api.post("/sms/webhook/regenerate");
    setPath(data.path);
    toast.success("New link ready");
  };
  return (
    <section className="bg-white border border-[#E0DFD6] rounded-xl" data-testid="sms-forwarder-card">
      <button onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between px-4 py-3 text-sm font-semibold text-[#3A3A35]" data-testid="sms-forwarder-toggle">
        {title}
        <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="px-4 pb-4 space-y-3 text-xs text-[#3A3A35]">
          <div className="flex items-center gap-2">
            <code className="flex-1 truncate bg-[#FAFAF6] border border-[#E0DFD6] rounded px-2 py-1.5" data-testid="sms-forwarder-url">{url || "Loading…"}</code>
            <button onClick={() => copyText(url, "link")} disabled={!url} className="h-8 px-3 rounded-full bg-[#385C4B] text-white inline-flex items-center gap-1" data-testid="sms-forwarder-copy">
              <Copy className="w-3.5 h-3.5" /> Copy
            </button>
            <button onClick={regen} className="h-8 px-3 rounded-full border border-[#C8553D]/40 text-[#C8553D] inline-flex items-center gap-1" data-testid="sms-forwarder-regen">
              <RotateCw className="w-3.5 h-3.5" /> New link
            </button>
          </div>
          <p className="text-[#6B6B61]">
            Forwarder app me ye link "Webhook URL" me daalo, Method <b>POST</b>. Duplicate code apne aap skip hote hain.
          </p>
        </div>
      )}
    </section>
  );
};
